import * as v1Constants from './v1/constants'
import * as v1Recipes from './v1/recipes'
import * as v1Prompts from './v1/prompts'
import * as v2Constants from './v2/constants'
import * as v2Recipes from './v2/recipes'
import * as v2Prompts from './v2/prompts'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const versions: Record<string, { label: string; constants: any; recipes: any; prompts: any }> = {
  v1: { label: 'V1 API', constants: v1Constants, recipes: v1Recipes, prompts: v1Prompts },
  v2: { label: 'V2 API', constants: v2Constants, recipes: v2Recipes, prompts: v2Prompts },
}

export default versions
